import { createAction } from '@reduxjs/toolkit';
import type { CreateReportListenerMessage } from '~/store/frontendState/createReport/createReport.sagas';
import type { CreateReportItem } from '~/store/frontendState/createReport/createReportItem';

export const createReportCreateRequest = createAction(
  'CREATE_REPORT_CREATE_REQUEST',
  (mapId: number) => ({
    payload: {
      mapId,
    },
  })
);

export const createReportAddItem = createAction(
  'CREATE_REPORT_ADD_ITEM',
  (item: CreateReportItem) => ({
    payload: {
      item,
    },
  })
);

export const createReportUpdateItem = createAction(
  'CREATE_REPORT_UPDATE_ITEM',
  (item: CreateReportItem) => ({
    payload: {
      item,
    },
  })
);

export const createReportRemoveItem = createAction(
  'CREATE_REPORT_REMOVE_ITEM',
  (hash: string) => ({
    payload: {
      hash,
    },
  })
);

export const createReportEventReceived = createAction(
  'CREATE_REPORT_EVENT_RECEIVED',
  (event: CreateReportListenerMessage) => ({
    payload: event,
  })
);
